"use client";
import SvgAddFilled from "./add-filled.svg.js";
import SvgAddOutlined from "./add-outlined.svg.js";
import SvgAddRound from "./add-round.svg.js";
import SvgAddSharp from "./add-sharp.svg.js";
import SvgBackspaceFilled from "./backspace-filled.svg.js";
import SvgBackspaceOutlined from "./backspace-outlined.svg.js";
import SvgBackspaceRound from "./backspace-round.svg.js";
import SvgBackspaceSharp from "./backspace-sharp.svg.js";
import SvgClearFilled from "./clear-filled.svg.js";
import SvgClearOutlined from "./clear-outlined.svg.js";
import SvgClearRound from "./clear-round.svg.js";
import SvgClearSharp from "./clear-sharp.svg.js";
import SvgMailFilled from "./mail-filled.svg.js";
import SvgMailOutlined from "./mail-outlined.svg.js";
import SvgMailRound from "./mail-round.svg.js";
import SvgMailSharp from "./mail-sharp.svg.js";
import SvgRemoveFilled from "./remove-filled.svg.js";
import SvgRemoveOutlined from "./remove-outlined.svg.js";
import SvgRemoveRound from "./remove-round.svg.js";
import SvgRemoveSharp from "./remove-sharp.svg.js";
import SvgSendFilled from "./send-filled.svg.js";
import SvgSendOutlined from "./send-outlined.svg.js";
import SvgSendRound from "./send-round.svg.js";
import SvgSendSharp from "./send-sharp.svg.js";
const add = {
  filled: SvgAddFilled,
  outlined: SvgAddOutlined,
  round: SvgAddRound,
  sharp: SvgAddSharp
};
const backspace = {
  filled: SvgBackspaceFilled,
  outlined: SvgBackspaceOutlined,
  round: SvgBackspaceRound,
  sharp: SvgBackspaceSharp
};
const clear = {
  filled: SvgClearFilled,
  outlined: SvgClearOutlined,
  round: SvgClearRound,
  sharp: SvgClearSharp
};
const mail = {
  filled: SvgMailFilled,
  outlined: SvgMailOutlined,
  round: SvgMailRound,
  sharp: SvgMailSharp
};
const remove = {
  filled: SvgRemoveFilled,
  outlined: SvgRemoveOutlined,
  round: SvgRemoveRound,
  sharp: SvgRemoveSharp
};
const send = {
  filled: SvgSendFilled,
  outlined: SvgSendOutlined,
  round: SvgSendRound,
  sharp: SvgSendSharp
};
export {
  add,
  backspace,
  clear,
  mail,
  remove,
  send
};
